import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { authApi } from './services/api';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Isletmeler from './pages/Isletmeler';
import Kullanicilar from './pages/Kullanicilar';
import Buyukbas from './pages/Buyukbas';
import BuyukbasImport from './pages/BuyukbasImport';
import Kucukbas from './pages/Kucukbas';
import KucukbasImport from './pages/KucukbasImport';
import AtYetistiricilik from './pages/AtYetistiricilik';
import Aricilik from './pages/Aricilik';
import AsyaCeylani from './pages/AsyaCeylani';
import CobanKopegi from './pages/CobanKopegi';
import TarlaBitkileri  from './pages/TarlaBitkileri';
import YemBitkileri    from './pages/YemBitkileri';
import BahceBitkileri  from './pages/BahceBitkileri';
import FaaliyetAgac from './pages/FaaliyetAgac';
import IsletmeFaaliyetBagi from './pages/IsletmeFaaliyetBagi';
import AraziVarligi   from './pages/AraziVarligi';
import MakineVarligi  from './pages/MakineVarligi';
import TasitVarligi   from './pages/TasitVarligi';
import TesisVarligi   from './pages/TesisVarligi';
import OrgYapisi from './pages/OrgYapisi';
import Raporlama from './pages/Raporlama';
import PivotRapor from './pages/PivotRapor';
import Finansal from './pages/Finansal';
import YetkilendirmeYonetimi from './pages/YetkilendirmeYonetimi';
import MenuYonetimi from './pages/MenuYonetimi';
import SayfaBaglantilari from './pages/SayfaBaglantilari';
import Layout from './components/Layout';
import GenelTanimlar from './pages/GenelTanimlar';
import IcKontrolAnaSayfa from './pages/IcKontrolAnaSayfa';
import IcKontrolRiskler from './pages/IcKontrolRiskler';
import IcKontrolStandartlar from './pages/IcKontrolStandartlar';
import IcKontrolFaaliyetler from './pages/IcKontrolFaaliyetler';
import IcKontrolBildirimler from './pages/IcKontrolBildirimler';
import PersonelSicil from './pages/PersonelSicil';
import PersonelKadro from './pages/PersonelKadro';
import PersonelAtama from './pages/PersonelAtama';
import PersonelIzin from './pages/PersonelIzin';
import PersonelPerformans from './pages/PersonelPerformans';
import PersonelMaas from './pages/PersonelMaas';
import Ybs from './pages/Ybs';
import Ybs2 from './pages/Ybs2';
import IsletmeDetay from './pages/IsletmeDetay';
import IsletmePano from './pages/IsletmePano';
import ZiyaretListesi   from './pages/ZiyaretListesi';
import ZiyaretRaporlari  from './pages/ZiyaretRaporlari';
import ZiyaretTanimlar   from './pages/ZiyaretTanimlar';
import ZiyaretTakvim     from './pages/ZiyaretTakvim';
import ZiyaretAylikRapor from './pages/ZiyaretAylikRapor';
import BilgiNotListesi from './pages/BilgiNotListesi';
import BilgiNotOnay    from './pages/BilgiNotOnay';
import BilgiNotArsiv   from './pages/BilgiNotArsiv';
import BilgiNotSablon  from './pages/BilgiNotSablon';
import SutUretimi from './pages/SutUretimi';
import SutUretimiExcel from './pages/SutUretimiExcel';
import ReferansDonem from './pages/ReferansDonem';
import TigemMobilDashboard from './TigemMobilDashboard';
import FaaliyetRaporTablolari from './pages/FaaliyetRaporTablolari';
import IsTakipPano    from './pages/IsTakipPano';
import IsTakipListesi from './pages/IsTakipListesi';
import IsTakipDetay   from './pages/IsTakipDetay';
import ToplantıListesi from './pages/ToplantıListesi';
import ToplantıDetay   from './pages/ToplantıDetay';
import EskPartiListesi from './pages/EskPartiListesi';
import EskPartiDetay   from './pages/EskPartiDetay';
import EskProjeDashboard from './pages/EskProjeDashboard';

const PrivateRoute = ({ children }: { children: React.ReactNode }) => {
  const [durum, setDurum] = useState<'kontrol' | 'gecerli' | 'gecersiz'>(
    localStorage.getItem('token') ? 'kontrol' : 'gecersiz'
  );

  useEffect(() => {
    if (durum !== 'kontrol') return;
    authApi.me()
      .then(() => setDurum('gecerli'))
      .catch(() => {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        setDurum('gecersiz');
      });
  }, []);

  useEffect(() => {
    const handleFocus = () => {
      if (!localStorage.getItem('token')) { setDurum('gecersiz'); return; }
      authApi.me().catch(() => {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        setDurum('gecersiz');
      });
    };
    window.addEventListener('focus', handleFocus);
    return () => window.removeEventListener('focus', handleFocus);
  }, []);

  if (durum === 'kontrol') return (
    <div style={{ display:'flex', alignItems:'center', justifyContent:'center', height:'100vh' }}>
      <div style={{ width:36, height:36, border:'3px solid #e0e0e0', borderTop:'3px solid #1a5276', borderRadius:'50%', animation:'spin 0.8s linear infinite' }} />
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
  if (durum === 'gecersiz') return <Navigate to="/login" />;
  return <>{children}</>;
};


// Bos sayfa - route'u olmayan menü öğeleri için
function BosRoute() {
  return (
    <div style={{ display:'flex', alignItems:'center', justifyContent:'center',
      height:'60vh', flexDirection:'column', color:'#aaa', gap:16 }}>
      <span style={{ fontSize:48 }}>📋</span>
      <p style={{ fontSize:16 }}>Bu menü öğesine henüz sayfa bağlanmamış.</p>
      <p style={{ fontSize:12 }}>Sistem Tanımları → Menü Yönetimi'nden bağlantı ekleyebilirsiniz.</p>
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<PrivateRoute><Layout /></PrivateRoute>}>
          <Route index element={<Dashboard />} />

          {/* Organizasyon */}
          <Route path="isletmeler" element={<Isletmeler />} />
          <Route path="org-yapisi" element={<OrgYapisi />} />
          <Route path="isletme-faaliyet-bagi" element={<IsletmeFaaliyetBagi />} />

          {/* Hayvancılık */}
          <Route path="buyukbas" element={<Buyukbas />} />
          <Route path="buyukbas-import" element={<BuyukbasImport />} />
          <Route path="kucukbas" element={<Kucukbas />} />
          <Route path="kucukbas-import" element={<KucukbasImport />} />
          <Route path="sut-uretimi" element={<SutUretimi />} />
          <Route path="sut-import" element={<SutUretimiExcel />} />
          <Route path="at" element={<AtYetistiricilik />} />
          <Route path="aricilik" element={<Aricilik />} />
          <Route path="asya-ceylani" element={<AsyaCeylani />} />
          <Route path="coban-kopegi" element={<CobanKopegi />} />

          {/* Bitkisel Üretim */}
          <Route path="tarla"  element={<TarlaBitkileri />} />
          <Route path="yem"    element={<YemBitkileri />} />
          <Route path="bahce"  element={<BahceBitkileri />} />

          {/* Varlık Yönetimi */}
          <Route path="arazi"  element={<AraziVarligi />} />
          <Route path="makine" element={<MakineVarligi />} />
          <Route path="tasit"  element={<TasitVarligi />} />
          <Route path="tesis"  element={<TesisVarligi />} />

          {/* Finansal */}
          <Route path="finansal" element={<Finansal />} />

          {/* Raporlar */}
          <Route path="raporlama" element={<Raporlama />} />
          <Route path="pivot-rapor" element={<PivotRapor />} />
          <Route path="faaliyet-rapor" element={<FaaliyetRaporTablolari />} />

          {/* Tanımlar */}
          <Route path="tanimlar" element={<FaaliyetAgac />} />

          {/* Sistem */}
          <Route path="referans-donem" element={<ReferansDonem />} />
          <Route path="kullanicilar" element={<Kullanicilar />} />
          <Route path="yetkilendirme" element={<YetkilendirmeYonetimi />} />
          <Route path="menu-yonetimi" element={<MenuYonetimi />} />
          <Route path="sayfa-baglantilari" element={<SayfaBaglantilari />} />
          <Route path="genel-tanimlar" element={<GenelTanimlar />} />
          <Route path="ybs" element={<Ybs />} />
          <Route path="ybs2" element={<Ybs2 />} />
          <Route path="isletme/:id" element={<IsletmeDetay />} />
          <Route path="isletme-pano" element={<IsletmePano />} />

          
          {/* İç Kontrol */}
          <Route path="ic-kontrol" element={<IcKontrolAnaSayfa />} />
          <Route path="ic-kontrol/riskler" element={<IcKontrolRiskler />} />
          <Route path="ic-kontrol/standartlar" element={<IcKontrolStandartlar />} />
          <Route path="ic-kontrol/faaliyetler" element={<IcKontrolFaaliyetler />} />
          <Route path="ic-kontrol/bildirimler" element={<IcKontrolBildirimler />} />

          {/* İnsan Kaynakları */}
          <Route path="personel/sicil" element={<PersonelSicil />} />
          <Route path="personel/kadro" element={<PersonelKadro />} />
          <Route path="personel/atama" element={<PersonelAtama />} />
          <Route path="personel/izin" element={<PersonelIzin />} />
          <Route path="personel/performans" element={<PersonelPerformans />} />
          <Route path="personel/maas" element={<PersonelMaas />} />

          {/* Ziyaret Takip */}
          <Route path="ziyaret"           element={<ZiyaretListesi />} />
          <Route path="ziyaret-takvim"    element={<ZiyaretTakvim />} />
          <Route path="ziyaret-rapor"     element={<ZiyaretRaporlari />} />
          <Route path="ziyaret-aylik"     element={<ZiyaretAylikRapor />} />
          <Route path="ziyaret-tanim"     element={<ZiyaretTanimlar />} />

          {/* Bilgi Notları */}
          <Route path="bilgi-notlarim"    element={<BilgiNotListesi />} />
          <Route path="bilgi-notu-onay"   element={<BilgiNotOnay />} />
          <Route path="bilgi-notu-arsiv"  element={<BilgiNotArsiv />} />
          <Route path="bilgi-notu-sablon" element={<BilgiNotSablon />} />

          {/* İş & Toplantı Takip */}
          <Route path="is-takip-pano"  element={<IsTakipPano />} />
          <Route path="is-takip"       element={<IsTakipListesi />} />
          <Route path="is-takip/:id"   element={<IsTakipDetay />} />
          <Route path="toplanti"       element={<ToplantıListesi />} />
          <Route path="toplanti/:id"   element={<ToplantıDetay />} />

          {/* ESK-TİGEM Parti Maliyet/Kâr-Zarar */}
          <Route path="esk-parti"            element={<EskPartiListesi />} />
          <Route path="esk-parti/:id"        element={<EskPartiDetay />} />
          <Route path="esk-parti-dashboard"  element={<EskProjeDashboard />} />

          <Route path="bos" element={<BosRoute />} />
        </Route>
        <Route path="/mobil" element={<TigemMobilDashboard />} />
        </Routes>
    </BrowserRouter>
  );
}
